import React from "react";
import { CompanyList, CriteriaList, ProjectList } from ".";

const PANELS = {
	criteria: {
		title: "dsi.form-studio.view.side-panel.criteria.title",
		panel: ({ row }) => <CriteriaList criteria={row} />,
	},
	companies: {
		title: "dsi.package-management.panel.companies.title",
		panel: ({ onUpdateRow, row, platformCompanies }) => (
			<CompanyList id={row?.id} platformCompanies={platformCompanies} onUpdateRow={onUpdateRow} />
		),
	},
	projects: {
		title: "dsi.package-management.panel.projects.title",
		panel: ({ row, projectsRequest, onUpdateRow }) => (
			<ProjectList projectsRequest={projectsRequest} view={row} onUpdateRow={onUpdateRow} />
		),
	},
};

export default PANELS;
